import { WarningTriangle } from '@elliemae/ds-icons';
import { put, takeLatest } from 'redux-saga/effects';
import Common from '../../common/services/Common';
import { openGlobalErrorModalAction } from '../../data/globalErrorModal/actionCreators';
import Session, { IS_SCENARIO_MODE } from '../../common/services/Session';
import { userRolesActions } from './index';

function* fetchUserClientRoles() {
  try {
    yield put(userRolesActions.setUserClientRolesLoading());

    const [, rightsResponse]: [void, any] = yield Promise.all([
      Common.setUserRoles(),
      Common.setClientRoles(),
    ]);

    const rights = rightsResponse?.rights ?? [];

    yield put(
      userRolesActions.setUserClientRolesSuccess({
        roleName: rightsResponse?.roleName ?? '',
        clientRoleId: rightsResponse?.clientRoleId ?? null,
        defaultView: rightsResponse?.defaultView ?? null,
        rights,
        canAssignLoanOfficer: rights.some(({ rightId }) => rightId === 28),
        viewDeliveryAndCommitment: rights.some(({ rightId }) => rightId === 12),
      }),
    );

    if (!rightsResponse?.rights && !Session.get(IS_SCENARIO_MODE)) {
      yield put(
        openGlobalErrorModalAction({
          title: 'You have not been assigned a role!',
          errorMessage:
            'You will have limited access to any features until you have been assigned a role. Please contact your administrator.',
          icon: <WarningTriangle size="xxl" color={['warning', '600']} />,
          onCloseCallback: () => Common.closeApplication(),
        }) as any,
      );
    }
  } catch (e) {
    yield put(userRolesActions.setUserClientRolesError(String(e)));
  }
}

export default function* watchers() {
  yield takeLatest(
    userRolesActions.fetchUserClientRoles.type as any,
    fetchUserClientRoles,
  );
}
